import type {
  InterventionFollowupFormProps,
  InterventionFollowupFormValues,
} from "./intervention-followup-form.type";

import { Checkbox, DatePicker, Form } from "antd";
import { useTranslation } from "react-i18next";

import { ModelDuplicateForm } from "@/modules/model-duplicate";

import { InterventionFollowupAlert } from "../intervention-followup-alert";

import { useInterventionFollowupForm } from "./intervention-followup-form.hook";

export const InterventionFollowupForm = (
  props: InterventionFollowupFormProps
) => {
  const { t } = useTranslation();
  const {
    form,
    formId,
    initialValues,
    onFormSubmit,
    isPending,
    validation,
    validationErrors,
  } = useInterventionFollowupForm(props);

  return (
    <>
      <InterventionFollowupAlert />
      <ModelDuplicateForm<InterventionFollowupFormValues>
        form={form}
        formId={formId}
        initialValues={initialValues}
        onFormSubmit={onFormSubmit}
        loading={isPending}
        validation={validation}
        validationErrors={validationErrors}
        submitText={t("followUp:button.label")}
        customFields={
          <>
            <Form.Item
              name="scheduled_date"
              label={t("intervention:form.scheduledDate.label")}
            >
              <DatePicker data-testid="scheduled_date" />
            </Form.Item>

            <Form.Item
              name="duplicate_completed_observations"
              valuePropName="checked"
              {...validation("duplicate_completed_observations")}
            >
              <Checkbox>{t("intervention:followUp.checkbox.label")}</Checkbox>
            </Form.Item>
          </>
        }
      />
    </>
  );
};
